import React from 'react';
import { CardContent } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import ResourceAllocationChartSkeleton from '../ResourceAllocationChart/ResourceAllocationChartSkeleton';
import ResourcingCard from '../ResourcingCard';
import { title, useContentStyles } from './ResourceAllocationCard';

const ResourceAllocationCardSkeleton = () => {
  const action = <Skeleton variant="rect" height={32} width={140} />;
  const contentStyles = useContentStyles();

  return (
    <ResourcingCard title={title} action={action}>
      <CardContent classes={contentStyles}>
        <ResourceAllocationChartSkeleton />
      </CardContent>
    </ResourcingCard>
  );
};

export default ResourceAllocationCardSkeleton;
